import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CartInterface } from '../../../entities/@shop/Cart/Cart';
import { AsyncReduxState, initialAsyncReduxState } from '../../defaults';

export type CartState = AsyncReduxState<{
    cart: CartInterface;
    isInitiallyLoading: boolean;
    isSuccessfulAdded: boolean;
    isSuccessfulRemoved: boolean;
}>;

export const defaultCart: CartInterface = {
    id: '',
    items: [],
    subTotalPrice: 0,
    handlingPrice: 0,
    totalPrice: 0,
    discounts: [],
};

const initialState: CartState = {
    ...initialAsyncReduxState,
    cart: defaultCart,
    isInitiallyLoading: false,
    isSuccessfulAdded: false,
    isSuccessfulRemoved: false,
};

const cartSlice = createSlice({
    name: 'cartSlice',
    initialState,
    reducers: {
        setIsInitiallyLoading(state, action: PayloadAction<boolean>): CartState {
            return {
                ...state,
                isInitiallyLoading: action.payload,
            };
        },
        setIsLoading(state, action: PayloadAction<boolean>): CartState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setHasFetched(state, action: PayloadAction<boolean>): CartState {
            return {
                ...state,
                hasFetched: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): CartState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): CartState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setCart(state, action: PayloadAction<CartInterface>): CartState {
            return {
                ...state,
                cart: action.payload,
            };
        },
        setIsSuccessfullyAdded(state, action: PayloadAction<boolean>): CartState {
            return {
                ...state,
                isSuccessfulAdded: action.payload,
            };
        },
        setIsSuccessfullyRemoved(state, action: PayloadAction<boolean>): CartState {
            return {
                ...state,
                isSuccessfulRemoved: action.payload,
            };
        },
    },
});

export const {
    setIsInitiallyLoading,
    setIsLoading,
    setHasFetched,
    setIsSuccessful,
    setError,
    setCart,
    setIsSuccessfullyAdded,
    setIsSuccessfullyRemoved,
} = cartSlice.actions;

export default cartSlice;
